import Page, {PageActionsType} from "components/common/page/Page";
import CheckAvailability from "components/entities/accommodation/availability/CheckAvailability";
import {faBed} from "@fortawesome/free-solid-svg-icons";
import {AppRoutes} from "../../../config/router";

const AccommodationAvailabilityPage = () => {

    const pageActions: PageActionsType = [
        {
            name: 'bookingDatalist',
            icon: faBed,
            link: AppRoutes.ACCOMMODATION_OVERVIEW_HOME,
            title: 'pages.accommodation.boooking.list'
        }
    ]

    return (
        <Page wFull title="pages.accommodation.availability" actions={pageActions}>
            <CheckAvailability name="accommodation-availability-page" />
        </Page>
    );
};

export default AccommodationAvailabilityPage;
